<div class="d-flex flex-column flex-root vh-100">
  <div
    class="d-flex flex-column flex-lg-row flex-column-fluid stepper stepper-pills stepper-column stepper-multistep"
  >
    <div class="d-flex flex-column flex-lg-row-auto w-lg-350px w-xl-500px">
      <div
        class="d-flex flex-column position-lg-fixed top-0 bottom-0 w-lg-350px w-xl-500px scroll-y bgi-size-cover bgi-position-center bg-create-account"
      >
        <div class="d-flex flex-center pt-20 pb-10 py-lg-20 mt-lg-20">
          <img alt="Logo" [src]="logoUrl()" class="h-70px" />
        </div>
        <div class="d-flex flex-row-fluid justify-content-center p-10">
          <div class="stepper-nav">
            @for (step of steps(); track step; let i = $index) {
              <div
                class="stepper-item"
                [ngClass]="{
                  current: currentStep() === i + 1,
                  completed: currentStep() > i + 1,
                }"
              >
                <div class="stepper-wrapper">
                  <div class="stepper-icon rounded-3">
                    <i class="ki-duotone fs-2 stepper-check ki-check"></i>
                    <span class="stepper-number">{{ i + 1 }}</span>
                  </div>
                  <div class="stepper-label">
                    <h3 class="stepper-title fs-2">{{ t()!(step.title) }}</h3>
                    <div class="stepper-desc fw-normal">
                      {{ t()!(step.text) }}
                    </div>
                  </div>
                </div>
                @if (i < steps().length - 1) {
                  <div class="stepper-line h-40px"></div>
                }
              </div>
            }
          </div>
        </div>

        <div class="d-flex flex-center flex-wrap px-5 py-10">
          <div class="d-flex fw-normal">
            @for (link of footerLinks(); track link) {
              <a
                [href]="link.link | absoluteUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="text-warning px-5"
                >{{ t()!(link.label) }}</a
              >
            }
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column flex-lg-row-fluid py-10">
      <div class="d-flex flex-center flex-column flex-column-fluid">
        <div class="w-lg-650px w-xl-700px p-10 p-lg-15 mx-auto w-100">
          <div class="my-auto pb-5 position-relative">
            <div class="current position-relative">
              <ng-container *ngComponentOutlet="component()"></ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
